import React from 'react'; 
import '../../../CSS/home_footer.scss';
import '../../../CSS/main.scss';

const HomeFooterContent = ({data})=> { 
  return (
    <div className="container">
        <div className="row">
            <div className="col-md-4 col-lg-4"></div>
            <div className="col-md-4 col-lg-4">
                <h5 className="header_or_link" style={{textAlign:"center"}}>{data.title}</h5>
                <p className="default-paragraph" style={{textAlign:"justify"}}>
                  {data.content}
                </p>
            </div>
            <div className="col-md-4 col-lg-4"></div>
        </div>
    </div>
  );
}

export default HomeFooterContent; 